import axios from 'axios';
const baseUrl = process.env.VUE_APP_API_BASE_URL;

axios.defaults.withCredentials = true;
export const instanceWithCredential = axios.create({
  baseURL: baseUrl,
  timeout: 180000,
  withCredentials: false,
});

instanceWithCredential.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['x-access-token'] = token;
  }
  return config;
});

export default instanceWithCredential;
